module.exports = __webpack_public_path__ + "img/9.d3f5de7d.jpg";